import React from 'react';
import {
  FaStore, FaMapMarkerAlt, FaUsers, FaLifeRing,
  FaBullhorn, FaHandshake
} from 'react-icons/fa';
import './Support.css'

const supportItems = [
  {
    title: "Complete Store Setup",
    desc: "From design to operations, we handle every aspect of store’s development.",
    icon: <FaStore />,
  },
  {
    title: "Prime Location Support",
    desc: "We help you find high-footfall areas for maximum success.",
    icon: <FaMapMarkerAlt />,
  },
  {
    title: "Skilled Staff & Training",
    desc: "Get expert recruitment and training for seamless operations.",
    icon: <FaUsers />,
  },
  {
    title: "Ongoing Business Support",
    desc: "We assist with daily tasks, troubleshooting, and efficiency.",
    icon: <FaLifeRing />,
  },
  {
    title: "Brand Growth & Marketing",
    desc: "Leverage our reputation and targeted campaigns to attract customers.",
    icon: <FaBullhorn />,
  },
  {
    title: "Customer Engagement",
    desc: "Stand out with our proven branding strategies.",
    icon: <FaHandshake />,
  },
];

export default function SupportSection() {
  return (
    <section className="support-section">
      <h2 className="support-title">Support We Will Provide</h2>
      <div className="support-grid">
        {supportItems.map((item, idx) => (
          <div key={idx} className="support-card">
            <div className="support-icon">{item.icon}</div>
            <div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
